<template>
  <v-card
    style="border-radius: 10px"
    flat
    :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
  >
    <v-toolbar flat dense class="beez-bold">
      <div v-if="input.files && input.files.length">
        <v-icon class="pr-3">attach_file</v-icon>
        {{ input.label }} ({{ input.files.length }})
      </div>
      <v-spacer></v-spacer>
      <v-btn flat icon @click="fileAttachmentPanel = !fileAttachmentPanel">
        <v-icon
          >{{ fileAttachmentPanel ? 'expand_less' : 'expand_more' }}
        </v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text v-if="fileAttachmentPanel">
      <v-layout align-center justify-space-around row fill-height wrap>
        <template v-for="(file, key) in input.files">
          <v-flex :key="key + 'file-flex'">
            <v-btn
              flat
              v-if="file.link.toString().startsWith('http')"
              class="beez-btn blue--text text-truncate"
              :href="file.link"
              target="_parent"
            >
              ({{ key + 1 }})
              <span class="text-truncate">&nbsp;{{ file.name }}</span>
            </v-btn>
            <v-btn
              flat
              v-else
              class="beez-btn blue--text text-truncate"
              :href="'/api/core/dms/read/' + file.link"
              target="_parent"
            >
              ({{ key + 1 }})
              <span class="text-truncate">&nbsp;{{ file.name }}</span>
            </v-btn>
          </v-flex>
        </template>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'FileAttachment',
  props: {
    input: Object
  },
  data() {
    return {
      fileAttachmentPanel: false
    }
  }
}
</script>

<style scoped></style>
